// import moment from "moment";
// class TimeDate {
//   durationTimeConverter = (arrivalTime, departureTime) => {
//     let startTime = moment(departureTime, "HH:mm:ss").format("LT");
//     let endTime = moment(arrivalTime, "HH:mm:ss ").format("LT");
//     startTime = moment(startTime, "HH:mm:ss a");
//     endTime = moment(endTime, "HH:mm:ss a");

//     const duration = moment.duration(endTime.diff(startTime));
//     const hours = parseInt(duration.asHours());
//     const minutes = parseInt(duration.asMinutes()) % 60;

//     return hours + "h " + minutes + "m";
//   };
//   dateValidation = (date) => {
//     try {
//       if (new Date().toLocaleDateString() === date) return true;
//       let today = new Date();
//       today.setHours(0, 0, 0, 0);
//       let newDate = date.split("/");
//       newDate = new Date(newDate[2], newDate[0] - 1, newDate[1]); // MM/DD/YYYY
//       return today <= newDate;
//     } catch (error) {
//       return false;
//     }

//   };
// }

// export default new TimeDate();
import moment from "moment";

export const durationTimeConverter = (arrivalTime, departureTime) => {
  const startTime = moment(departureTime, "HH:mm:ss").format("LT");
  const endTime = moment(arrivalTime, "HH:mm:ss").format("LT");
  const startMoment = moment(startTime, "h:mm A");
  const endMoment = moment(endTime, "h:mm A");

  const duration = moment.duration(endMoment.diff(startMoment));
  const hours = parseInt(duration.asHours());
  const minutes = parseInt(duration.asMinutes()) % 60;

  return hours + "h " + minutes + "m";
};

export const dateValidation = (date) => {
  try {
    const today = new Date();
    today.setHours(0, 0, 0, 0);

    const newDate = new Date(date); // Assuming date is in format "MM/DD/YYYY" or "YYYY-MM-DD"
    newDate.setHours(0, 0, 0, 0);

    return today <= newDate;
  } catch (error) {
    return false;
  }
};
